// extracted by mini-css-extract-plugin
module.exports =  {"turnsFooter":"Q2uma22pdhdQYJkn1pMt","logos":"Tgp6O3yPsgyWAJ_aFOW8"};